import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [
    "userId",
    "userName",
    "businessClientId",
    "password"
  ]
  
  static values = { 
  }

  connect() {
    // ScormProcessInitialize()
    // let completionStatus = ScormProcessGetValue("cmi.completion_status", true);

    // if (completionStatus == "unknown") {
    //   ScormProcessSetValue("cmi.completion_status", "incomplete");
    // }

    window.addEventListener("message", event => {
      this.userIdTarget.innerText = event.data.user_id
      this.userNameTarget.innerText = event.data.user_name
      this.businessClientIdTarget.innerText = event.data.business_client_id
      this.passwordTarget.innerText = event.data.token
    })
  }

  passed() {
    parent.postMessage("passed","*")
    // ScormProcessSetValue("cmi.score.raw", "100");
    // ScormProcessSetValue("cmi.score.min", "0");
    // ScormProcessSetValue("cmi.score.max", "100");
    // ScormProcessSetValue("cmi.score.scaled", "1");
    // ScormProcessSetValue("cmi.success_status", "passed");
    // ScormProcessSetValue("cmi.completion_status", "completed");
  }

  notPassed() {
    parent.postMessage("notPassed","*")
    // ScormProcessSetValue("cmi.score.raw", "0");
    // ScormProcessSetValue("cmi.score.min", "0");
    // ScormProcessSetValue("cmi.score.max", "100");
    // ScormProcessSetValue("cmi.score.scaled", "0");
    // ScormProcessSetValue("cmi.success_status", "failed");
    // ScormProcessSetValue("cmi.completion_status", "completed");
  }

}